var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnglish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 18,
    viewBox: "0 0 31 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.949219 18V16.5234L2.85938 16.1953V2.75391L0.949219 2.42578V0.9375H13.582V5.03906H11.7305L11.4727 2.71875H5.16797V8.27344H11.4609V10.0898H5.16797V16.2656H11.8477L12.1055 13.9102H13.9453V18H0.949219ZM16.1719 18V16.5234L18.082 16.1953V7.13672L16.1719 6.80859V5.32031H20.1445L20.3086 7.20703C20.7305 6.53516 21.2578 6.01562 21.8906 5.64844C22.5312 5.27344 23.2578 5.08594 24.0703 5.08594C25.4375 5.08594 26.4961 5.48828 27.2461 6.29297C27.9961 7.08984 28.3711 8.32422 28.3711 9.99609V16.1953L30.2812 16.5234V18H24.1523V16.5234L26.0625 16.1953V10.043C26.0625 8.92578 25.8398 8.13281 25.3945 7.66406C24.957 7.19531 24.2852 6.96094 23.3789 6.96094C22.7148 6.96094 22.125 7.12109 21.6094 7.44141C21.1016 7.76172 20.6953 8.19922 20.3906 8.75391V16.1953L22.3008 16.5234V18H16.1719Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglish);
export default __webpack_public_path__ + "static/media/English.437340b3a2bf8d2a134a0b098e92ba8d.svg";
export { ForwardRef as ReactComponent };